/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/prop-types */
import React from "react";
import "icheck/skins/all.css";
import { Checkbox } from "react-icheck";
import { withStyles } from "@material-ui/core/styles";
import { Collapse } from "react-bootstrap";

import NeighborhoodFilter from "../components/NeighborhoodFilter";
import PlacesSearchFilter from "../components/PlacesSearchFilter";
import PoolFilter from "../components/PoolFilter";

const styles = theme => ({
  header: {
    height: "50px",
    color: "#f44336",
    boxShadow: "none",
    borderBottom: "1px solid #e2e2e2",
    marginTop: "145px"
  },
  toolbar: {
    height: "65px",
    display: "flex",
    justifyContent: "space-between",
    padding: "0 0px 0 0px"
  },
  leftGrid: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center"
  },
  rightGrid: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  },

  root: {
    width: "100%"
  },

  buttons: {
    margin: "0 0px",
    minHeight: 20,
    padding: "5px 10px"
  },
  advancedSearch: {
    width: "50%",
    marginTop: "3px"
  },
  title: {
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "block"
    }
  },
  AirBnbSwitchBase: {
    "&$AirBnbChecked": {
      color: "white",
      "& + $AirBnbBar": {
        backgroundColor: theme.palette.secondary.light
      }
    },
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.sharp
    })
  },
  AirBnbChecked: {
    transform: "translateX(15px)",
    "& + $AirBnbBar": {
      opacity: 1,
      border: "none"
    }
  },
  AirBnbBar: {
    borderRadius: 25,
    width: 48,
    height: 31,
    marginTop: -16,
    marginLeft: -24,
    border: "solid 1px",
    borderColor: theme.palette.secondary.light,
    backgroundColor: theme.palette.grey[50],
    opacity: 1,
    transition: theme.transitions.create(["background-color", "border"])
  },
  AirBnbIcon: {
    width: 30,
    height: 30
  },
  AirBnbIconChecked: {
    boxShadow: theme.shadows[1]
  }
});

class FilterBar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      address: null
    };
  }

  componentDidMount() {
    this.setState({ address: this.props.listingFilter.searchStr });
  }

  render() {
    const {
      classes,
      handleChange,
      updateFilter,
      listingFilter,
      advancedSearchCollapsed,
      toggleAdvancedSearch,
      searchId
    } = this.props;

    const handleStatusChange = (e, checked, statusType) => {
      const prevStatus = listingFilter.status && listingFilter.status.slice();

      const isCurrentlySelected =
        prevStatus && prevStatus.indexOf(statusType) > -1;

      if (checked && !isCurrentlySelected) {
        prevStatus.push(statusType);
        updateFilter({ status: prevStatus });
      }

      if (!checked && isCurrentlySelected) {
        updateFilter({ status: prevStatus.filter(s => s !== statusType) });
      }
    };

    const location = new window.google.maps.LatLng(
      35.39032338025625,
      -89.26065817950166
    );

    const clearAllFilters = () => {
      this.setState({ address: null });
      this.props.clearFilter();
    };

    return (
      <div className={classes.root}>
        <div className="search-bar d-md-block d-none">
          <div className="container-fluid px-0">
            <div
              className="search-container mr-0 ml-0 py-4"
              onMouseLeave={() => {
                if (!advancedSearchCollapsed) {
                  toggleAdvancedSearch();
                }
              }}
            >
              <div className="row mr-0 ml-0">
                <div className="col-12 col-lg-9">
                  <div className="row">
                    <div className="col-12 col-md-12 col-lg-4">
                      <PlacesSearchFilter
                        listingFilter={listingFilter}
                        updateFilter={updateFilter}
                        searchId={searchId}
                      ></PlacesSearchFilter>
                    </div>
                    <div className="col-12 col-md-6 col-lg-2">
                      <select
                        className="custom-select mr-sm-2 "
                        style={{ width: "100%" }}
                        name="beds"
                        value={listingFilter.beds || ""}
                        onChange={event =>
                          updateFilter({ beds: event.target.value })
                        }
                      >
                        <option>Beds</option>
                        <option value="1">1+ Beds</option>
                        <option value="2">2+ Beds</option>
                        <option value="3">3+ Beds</option>
                        <option value="4">4+ Beds</option>
                        <option value="5">5+ Beds</option>
                      </select>
                    </div>
                    <div className="col-12 col-md-6 col-lg-2">
                      <select
                        className="custom-select mr-sm-2 "
                        style={{ width: "100%" }}
                        name="baths"
                        value={listingFilter.baths || ""}
                        onChange={event =>
                          updateFilter({ baths: event.target.value })
                        }
                      >
                        <option>Baths</option>
                        <option value="1">1+</option>
                        <option value="2">2+</option>
                        <option value="3">3+</option>
                        <option value="4">4+</option>
                        <option value="5">5+</option>
                      </select>
                    </div>
                    <div className="col-12 col-md-6 col-lg-2">
                      <select
                        id="priceMin"
                        className="form-control"
                        style={{ width: "100%" }}
                        name="priceMin"
                        value={listingFilter.priceMin || ""}
                        onChange={event =>
                          updateFilter({ priceMin: event.target.value })
                        }
                      >
                        <option value="">Price Min</option>
                        <option value="10000">$10K</option>
                        <option value="20000">$20K</option>
                        <option value="25000">$25K</option>
                        <option value="30000">$30K</option>
                        <option value="40000">$40K</option>
                        <option value="50000">$50K</option>
                        <option value="60000">$60K</option>
                        <option value="70000">$70K</option>
                        <option value="75000">$75K</option>
                        <option value="80000">$80K</option>
                        <option value="90000">$90K</option>
                        <option value="100000">$100K</option>
                        <option value="110000">$110K</option>
                        <option value="120000">$120K</option>
                        <option value="125000">$125K</option>
                        <option value="130000">$130K</option>
                        <option value="140000">$140K</option>
                        <option value="150000">$150K</option>
                        <option value="160000">$160K</option>
                        <option value="170000">$170K</option>
                        <option value="175000">$175K</option>
                        <option value="180000">$180K</option>
                        <option value="190000">$190K</option>
                        <option value="200000">$200K</option>
                        <option value="210000">$210K</option>
                        <option value="220000">$220K</option>
                        <option value="230000">$230K</option>
                        <option value="240000">$240K</option>
                        <option value="250000">$250K</option>
                        <option value="275000">$275K</option>
                        <option value="300000">$300K</option>
                        <option value="325000">$325K</option>
                        <option value="350000">$350K</option>
                        <option value="375000">$375K</option>
                        <option value="400000">$400K</option>
                        <option value="425000">$425K</option>
                        <option value="450000">$450K</option>
                        <option value="475000">$475K</option>
                        <option value="500000">$500K</option>
                        <option value="525000">$525K</option>
                        <option value="550000">$550K</option>
                        <option value="575000">$575K</option>
                        <option value="600000">$600K</option>
                        <option value="625000">$625K</option>
                        <option value="650000">$650K</option>
                        <option value="675000">$675K</option>
                        <option value="700000">$700K</option>
                        <option value="725000">$725K</option>
                        <option value="750000">$750K</option>
                        <option value="775000">$775K</option>
                        <option value="800000">$800K</option>
                        <option value="825000">$825K</option>
                        <option value="850000">$850K</option>
                        <option value="875000">$875K</option>
                        <option value="900000">$900K</option>
                        <option value="925000">$925K</option>
                        <option value="950000">$950K</option>
                        <option value="975000">$975K</option>
                        <option value="1000000">$1M</option>
                        <option value="1100000">$1.1M</option>
                        <option value="1200000">$1.2M</option>
                        <option value="1300000">$1.3M</option>
                        <option value="1400000">$1.4M</option>
                        <option value="1500000">$1.5M</option>
                        <option value="1600000">$1.6M</option>
                        <option value="1700000">$1.7M</option>
                        <option value="1800000">$1.8M</option>
                        <option value="1900000">$1.9M</option>
                        <option value="2000000">$2M</option>
                        <option value="2250000">$2.25M</option>
                        <option value="2500000">$2.5M</option>
                        <option value="2750000">$2.75M</option>
                        <option value="3000000">$3M</option>
                        <option value="3500000">$3.5M</option>
                        <option value="4000000">$4M</option>
                        <option value="4500000">$4.5M</option>
                        <option value="5000000">$5M</option>
                      </select>
                    </div>

                    <div className="col-12 col-md-6 col-lg-2">
                      <select
                        id="priceMax"
                        className="form-control"
                        style={{ width: "100%" }}
                        name="priceMax"
                        value={listingFilter.priceMax || ""}
                        onChange={event =>
                          updateFilter({ priceMax: event.target.value })
                        }
                      >
                        <option value="">Price Max</option>
                        <option value="90000">$90K</option>
                        <option value="100000">$100K</option>
                        <option value="110000">$110K</option>
                        <option value="120000">$120K</option>
                        <option value="125000">$125K</option>
                        <option value="130000">$130K</option>
                        <option value="140000">$140K</option>
                        <option value="150000">$150K</option>
                        <option value="160000">$160K</option>
                        <option value="170000">$170K</option>
                        <option value="175000">$175K</option>
                        <option value="180000">$180K</option>
                        <option value="190000">$190K</option>
                        <option value="200000">$200K</option>
                        <option value="210000">$210K</option>
                        <option value="220000">$220K</option>
                        <option value="230000">$230K</option>
                        <option value="240000">$240K</option>
                        <option value="250000">$250K</option>
                        <option value="275000">$275K</option>
                        <option value="300000">$300K</option>
                        <option value="325000">$325K</option>
                        <option value="350000">$350K</option>
                        <option value="375000">$375K</option>
                        <option value="400000">$400K</option>
                        <option value="425000">$425K</option>
                        <option value="450000">$450K</option>
                        <option value="475000">$475K</option>
                        <option value="500000">$500K</option>
                        <option value="525000">$525K</option>
                        <option value="550000">$550K</option>
                        <option value="575000">$575K</option>
                        <option value="600000">$600K</option>
                        <option value="625000">$625K</option>
                        <option value="650000">$650K</option>
                        <option value="675000">$675K</option>
                        <option value="700000">$700K</option>
                        <option value="725000">$725K</option>
                        <option value="750000">$750K</option>
                        <option value="775000">$775K</option>
                        <option value="800000">$800K</option>
                        <option value="825000">$825K</option>
                        <option value="850000">$850K</option>
                        <option value="875000">$875K</option>
                        <option value="900000">$900K</option>
                        <option value="925000">$925K</option>
                        <option value="950000">$950K</option>
                        <option value="975000">$975K</option>
                        <option value="1000000">$1M</option>
                        <option value="1100000">$1.1M</option>
                        <option value="1200000">$1.2M</option>
                        <option value="1300000">$1.3M</option>
                        <option value="1400000">$1.4M</option>
                        <option value="1500000">$1.5M</option>
                        <option value="1600000">$1.6M</option>
                        <option value="1700000">$1.7M</option>
                        <option value="1800000">$1.8M</option>
                        <option value="1900000">$1.9M</option>
                        <option value="2000000">$2M</option>
                        <option value="2250000">$2.25M</option>
                        <option value="2500000">$2.5M</option>
                        <option value="2750000">$2.75M</option>
                        <option value="3000000">$3M</option>
                        <option value="3500000">$3.5M</option>
                        <option value="4000000">$4M</option>
                        <option value="4500000">$4.5M</option>
                        <option value="5000000">$5M</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-lg-3 px-0">
                  <button
                    type="button"
                    style={{ marginTop: "3px", marginRight: "10px" }}
                    className="btn btn-primary col-5"
                    onClick={() => toggleAdvancedSearch()}
                  >
                    Search
                  </button>
                  <button
                    type="button"
                    style={{ marginTop: "3px" }}
                    className="btn btn-light col-5"
                    onClick={() => clearAllFilters()}
                  >
                    Clear Filters
                  </button>
                </div>
              </div>
              <div className="row">
                <Collapse
                  in={!advancedSearchCollapsed}
                  style={{ width: "100%", paddingLeft: "20px" }}
                >
                  <div className="container-fluid pb-4">
                    <div className="row pt-4 expandedSearch">
                      <div className="col-lg-5 col-md-12 py-2">
                        <NeighborhoodFilter
                          listingFilter={listingFilter}
                          updateFilter={updateFilter}
                        />
                        <div className="rangeSelections row pt-4">
                          <div className="col-3 text-right">Square Ft</div>
                          <input
                            name="sqftMin"
                            className="form-control col-4"
                            value={listingFilter.sqftMin || ""}
                            onChange={e =>
                              handleChange(e.target.value, "sqftMin")
                            }
                            onBlur={event =>
                              updateFilter({
                                sqftMin: event.target.value
                              })
                            }
                          />
                          <span className="separator">to</span>
                          <input
                            name="sqftMax"
                            className="form-control col-4"
                            value={listingFilter.sqftMax || ""}
                            onChange={e =>
                              handleChange(e.target.value, "sqftMax")
                            }
                            onBlur={event =>
                              updateFilter({
                                sqftMax: event.target.value
                              })
                            }
                          />
                        </div>
                        <div className="rangeSelections row pt-4">
                          <div className="col-3 text-right">Year Built</div>
                          <input
                            name="yearMin"
                            className="form-control col-4"
                            value={listingFilter.yearMin || ""}
                            onChange={e =>
                              handleChange(e.target.value, "yearMin")
                            }
                            onBlur={event =>
                              updateFilter({
                                yearMin: event.target.value
                              })
                            }
                          />
                          <span className="separator">to</span>
                          <input
                            name="yearMax"
                            className="form-control col-4"
                            value={listingFilter.yearMax || ""}
                            onChange={e =>
                              handleChange(e.target.value, "yearMax")
                            }
                            onBlur={event =>
                              updateFilter({
                                yearMax: event.target.value
                              })
                            }
                          />
                        </div>
                        <div className="rangeSelections row pt-4">
                          <div className="col-3 text-right">Acreage</div>
                          <input
                            name="acreageMin"
                            className="form-control col-4"
                            value={listingFilter.acreageMin || ""}
                            onChange={e =>
                              handleChange(e.target.value, "acreageMin")
                            }
                            onBlur={event =>
                              updateFilter({
                                acreageMin: event.target.value
                              })
                            }
                          />
                          <span className="separator">to</span>
                          <input
                            name="acreageMax"
                            className="form-control col-4"
                            value={listingFilter.acreageMax || ""}
                            onChange={e =>
                              handleChange(e.target.value, "acreageMax")
                            }
                            onBlur={event =>
                              updateFilter({
                                acreageMax: event.target.value
                              })
                            }
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-12 py-2">
                        <PoolFilter
                          listingFilter={listingFilter}
                          updateFilter={updateFilter}
                        ></PoolFilter>

                        <div className="pt-2 pl-5 form-group row">
                          <label className="col-form-label col-xl-4 col-md-4 pl-0 text-right">
                            Days on Market
                          </label>

                          <select
                            className="select custom-select col-8"
                            name="daysOnMarketStr"
                            value={listingFilter.daysOnMarketStr || ""}
                            onChange={event =>
                              updateFilter({
                                daysOnMarketStr: event.target.value
                              })
                            }
                          >
                            <option value="">Any</option>
                            <option value="24h">Last 24 hours</option>
                            <option value="1w">Within last week</option>
                            <option value="1m">Within last month</option>
                            <option value="3m">Within last 3 month</option>
                            <option value="46m">4 to 6 months</option>
                            <option value="6m">6+ months</option>
                          </select>
                        </div>
                        <div className="pt-2 pl-5 form-group row">
                          <label
                            className="col-form-label col-xl-4 col-md-4 pl-0 text-right"
                            htmlFor="coveredParking"
                          >
                            Covered Parking
                          </label>
                          <select
                            className="custom-select mr-sm-2 col-3"
                            name="coveredParking"
                            id="coveredParking"
                            value={listingFilter.coveredParking || ""}
                            onChange={event =>
                              updateFilter({
                                coveredParking: event.target.value
                              })
                            }
                          >
                            <option value="">Any</option>
                            <option value="1">1+</option>
                            <option value="2">2+</option>
                            <option value="3">3+</option>
                            <option value="4">4+</option>
                          </select>
                        </div>
                        <div className="pt-2 pl-5 form-group row">
                          <label className="col-xl-4 col-md-4 pl-0 text-right">
                            Status
                          </label>
                          <div className="col-md-8 px-0">
                            <div className="col-md-12">
                              <Checkbox
                                checkboxClass="icheckbox_flat-blue"
                                increaseArea="20%"
                                label=" Active"
                                checked={true}
                                onChange={(e, checked) =>
                                  handleStatusChange(e, checked, "ACT")
                                }
                              />
                            </div>
                            <div className="col-md-12">
                              <Checkbox
                                checkboxClass="icheckbox_flat-blue"
                                increaseArea="20%"
                                label=" Contingent"
                                checked={
                                  listingFilter.status &&
                                  listingFilter.status.indexOf("CNTG") > -1
                                }
                                onChange={(e, checked) =>
                                  handleStatusChange(e, checked, "CNTG")
                                }
                              />
                            </div>
                            <div className="col-md-12">
                              <Checkbox
                                checkboxClass="icheckbox_flat-blue"
                                increaseArea="20%"
                                label=" Pending"
                                checked={
                                  listingFilter.status &&
                                  listingFilter.status.indexOf("PEND") > -1
                                }
                                onChange={(e, checked) =>
                                  handleStatusChange(e, checked, "PEND")
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-12 py-2">
                        <div className="form-check form-check-inline pl-5 pt-2 justify-content-start d-block">
                          <Checkbox
                            checkboxClass="icheckbox_flat-blue"
                            increaseArea="20%"
                            label=" New Construction"
                            checked={listingFilter.newConstruction}
                            onChange={(e, checked) =>
                              updateFilter({
                                newConstruction: checked ? 1 : 0
                              })
                            }
                          />
                        </div>
                        <div className="form-check form-check-inline pl-5 pt-2 justify-content-start">
                          <Checkbox
                            checkboxClass="icheckbox_flat-blue"
                            increaseArea="20%"
                            label=" Guest House/In-Law Quarters"
                            checked={listingFilter.guestHouse}
                            onChange={(e, checked) =>
                              updateFilter({
                                guestHouse: checked ? 1 : 0
                              })
                            }
                          />
                        </div>
                        <div className="form-check form-check-inline col pl-5 pt-2 justify-content-start">
                          <Checkbox
                            checkboxClass="icheckbox_flat-blue"
                            increaseArea="20%"
                            label=" Hobson Listings Only"
                            checked={listingFilter.hobsonOnly}
                            onChange={(e, checked) =>
                              updateFilter({
                                hobsonOnly: checked ? 1 : 0
                              })
                            }
                          />
                        </div>

                        <div className="form-check form-check-inline col pl-5 pt-2 justify-content-start">
                          <Checkbox
                            checkboxClass="icheckbox_flat-blue"
                            increaseArea="20%"
                            label=" Master Bed Down"
                            checked={listingFilter.masterBedDown}
                            onChange={(e, checked) =>
                              updateFilter({
                                masterBedDown: checked ? 1 : 0
                              })
                            }
                          />
                        </div>
                        <div className="form-check form-check-inline col pl-5 pt-2 justify-content-start">
                          <Checkbox
                            checkboxClass="icheckbox_flat-blue"
                            increaseArea="20%"
                            label=" Has Open House"
                            checked={listingFilter.hasOpenHouse}
                            onChange={(e, checked) =>
                              updateFilter({
                                hasOpenHouse: checked ? 1 : 0
                              })
                            }
                          />
                        </div>

                        <div className="form-check form-check-inline col pl-5 pt-2 justify-content-start">
                          <Checkbox
                            checkboxClass="icheckbox_flat-blue"
                            increaseArea="20%"
                            label=" Condo"
                            checked={listingFilter.condosOnly}
                            onChange={(e, checked) =>
                              updateFilter({
                                condosOnly: checked ? 1 : 0
                              })
                            }
                          />
                        </div>
                        <div className="form-check form-check-inline col pl-5 pt-2 justify-content-start">
                          <Checkbox
                            checkboxClass="icheckbox_flat-blue"
                            increaseArea="20%"
                            label=" Zero Lot Line"
                            checked={listingFilter.isZeroLotLine}
                            onChange={(e, checked) =>
                              updateFilter({
                                isZeroLotLine: checked ? 1 : 0
                              })
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </Collapse>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(FilterBar);
// export default FilterBar;
